import type { TutorTasksFilterParams } from '../../model/tutor-tasks/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorTasksExportApiOptions {
  params: TutorTasksFilterParams & { discipline?: number | string }
  onStart?: () => void
  onFinish?: () => void
}

/** `POST /admin-api/tutor-tasks/export` — answers 202 at once; the CSV is e-mailed to the admin later. */
export const useTutorTasksExportApi = async (options: TutorTasksExportApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutor-tasks.export')

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    const { data } = await $axios.post<ApiResponse>(url, options.params)
    toast.success(data.message)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    options.onFinish?.()
  }
}
